<div fxLayout="column" fxHide.lt-md>
    <!-- IE requires all fxLayout="column" elements to have the child contents wrapped in a plain div tag -->
    <div *ngIf="isBrowserIE; else paymentNoteListFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
        <ng-container *ngTemplateOutlet="paymentNoteListFlexColumnTemplate"></ng-container>
    </div>
</div>

<div fxLayout="column" fxHide.gt-sm>
    <div *ngIf="isBrowserIE; else paymentNoteListCardViewTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
        <div fxFlex.lt-sm="10px" fxFlex.gt-sm="25px">&nbsp;</div>
        <ng-container *ngTemplateOutlet="paymentNoteListCardViewTemplate"></ng-container>
    </div>
</div>

<ng-template #paymentNoteListCardViewTemplate>
    <div fxLayout="column" *ngIf="!showSpinner">
        <div *ngIf="isBrowserIE; else paymentNoteListCardViewHeaderTemplate"
            [ngClass]="{ 'ie-display': isBrowserIE }">
            <ng-container *ngTemplateOutlet="paymentNoteListCardViewHeaderTemplate"></ng-container>
        </div>
    </div>
    <div fxLayout="column">
        <!-- <div class="display-text primary-dark-color-important normal-paragraph-spacing">
            <b><span
                    i18n="@@payment-note.stepper.step1.pending-payments">payment-note.stepper.step1.pending-payments</span>&nbsp;
                {{ pendingPayment.pendingPaymentAmt }}</b>
        </div>         -->
        <!-- Filter Control -->


        <mat-form-field *ngIf="openNotesPaymentInfoList.length > 5" appearance="fill" style="width: 100%;">
            <mat-label>Filter by Note Status</mat-label>
            <mat-select [(ngModel)]="selectedNoteStatus" (selectionChange)="filterNotes()">
                <mat-option *ngFor="let status of uniqueNoteStatuses" [value]="status">
                    {{ status }}
                </mat-option>
                <mat-option [value]="''">All</mat-option>
            </mat-select>
        </mat-form-field>
        <ng-container *ngFor="let row of filteredNotesList"> <!-- TODO: use the list with footers -->
            <ng-container *ngIf="row.hasOwnProperty('isGroupFooter')">
                <mat-card style="background-color: #e3f2fd;">
                    <mat-card-title>
                        <span class="header-superscript" [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                            i18n="@@quick-pay-payment-amount.table.group-footer.pay-group">quick-pay-payment-amount.table.group-footer.pay-group</span>
                    </mat-card-title>
                    <mat-card-content>


                        <div style="display: flex; justify-content: space-between;">
                            <mat-label><span class="header-superscript header-after-content-3"
                                    [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                                    i18n="@@payment-note-list.table.column-header.total-amount-due">payment-note-list.table.column-header.total-amount-due</span></mat-label>
                            <span style="text-align: right;">{{
                                row.totalAmountDueTotal | currency
                                }}</span>
                        </div>



                    </mat-card-content>
                    <mat-card-actions style="display: flex; justify-content: right; align-items: right;">
                        <button mat-flat-button color="primary" (click)="selectPayGroup(row.paymentGroup)"
                            i18n-matTooltip="@@payment-note-list.table.column.options.button.tool-tip"
                            matTooltip="payment-note-list.table.column.options.button.tool-tip"
                            i18n="@@payment-note-list.table.column.options.button.label">
                            payment-note-list.table.column.options.button.label
                        </button>
                    </mat-card-actions>
                </mat-card>
            </ng-container>

            <ng-container *ngIf="!row.hasOwnProperty('isGroupFooter')">
                <mat-card *ngIf="row.noteId">
                    <mat-card-content>
                        <div style="width: 100%;">
                            <!-- Left Section: Note ID and Note Status -->
                            <div>
                                <mat-card-title>{{ row.noteId }}
                                    <a class="tooltip-link" (click)="openToolTip('noteId')"
                                        style="display: inline-flex; align-items: center; vertical-align: middle;">
                                        <mat-icon class="tooltip-icon-link"
                                            style="font-size: 16px; vertical-align: middle; margin-left: 4px;"
                                            matTooltip="{{ getToolTip('noteId') }}" matTooltipPosition="after"
                                            matTooltipClass="tooltip-multi-line">help_outline</mat-icon>
                                    </a>
                                </mat-card-title>
                                <mat-card-subtitle>{{ row.noteStatus }}
                                    <a class="tooltip-link" (click)="openToolTip('noteStatus')"
                                        style="display: inline-flex; align-items: center; vertical-align: middle;">
                                        <mat-icon class="tooltip-icon-link"
                                            style="font-size: 16px; vertical-align: middle; margin-left: 4px;"
                                            matTooltip="{{ getToolTip('noteStatus') }}" matTooltipPosition="after"
                                            matTooltipClass="tooltip-multi-line">help_outline</mat-icon>
                                    </a>
                                </mat-card-subtitle>
                                <div style="display: flex; justify-content: space-between;">
                                    <mat-label><span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                                            i18n="@@payment-note-list.table.column-header.next-payment-due-date">payment-note-list.table.column-header.next-payment-due-date</span></mat-label>
                                    <span style="text-align: right;">{{ row.nextPaymentDueDate }}</span>
                                </div>
                                <div *ngIf="row.pastDueAmount > 0"
                                    style="display: flex; justify-content: space-between;">
                                    <mat-label> <span class="header-superscript header-after-content-2"
                                            [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                                            i18n="@@payment-note-list.table.column-header.past-due-amount">payment-note-list.table.column-header.past-due-amount</span></mat-label>
                                    <span style="text-align: right;">{{ row.pastDueAmount | currency }}</span>
                                </div>
                                <div *ngIf="row.lateFeeDue > 0" style="display: flex; justify-content: space-between;">
                                    <mat-label><span class="header-superscript header-after-content-1"
                                            [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                                            i18n="@@payment-note-list.table.column-header.late-fee-due">payment-note-list.table.column-header.late-fee-due</span></mat-label>
                                    <span style="text-align: right;">{{ row.lateFeeDue | currency}}</span>
                                </div>
                                <div style="display: flex; justify-content: space-between;">
                                    <mat-label><span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                                            i18n="@@payment-note-list.table.column-header.regular-payment-amount">payment-note-list.table.column-header.regular-payment-amount</span></mat-label>
                                    <span style="text-align: right;">{{ row.regularPaymentAmount | currency}}</span>
                                </div>
                                <div style="display: flex; justify-content: space-between;">
                                    <mat-label><span class="header-superscript"
                                            [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                                            i18n="@@payment-note-list.table.column-header.auto-pay-flag">payment-note-list.table.column-header.auto-pay-flag</span></mat-label>
                                    <span style="text-align: right;">{{
                                        row.autoPayFlag
                                        }}</span>
                                </div>
                                <div style="display: flex; justify-content: space-between;">
                                    <mat-label><span class="header-superscript header-after-content-3"
                                            [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                                            i18n="@@payment-note-list.table.column-header.total-amount-due">payment-note-list.table.column-header.total-amount-due</span></mat-label>
                                    <span style="text-align: right;">{{
                                        row.totalAmountDue | currency
                                        }}</span>
                                </div>
                            </div>
                        </div>
                    </mat-card-content>
                    <mat-card-actions style="display: flex; justify-content: right; align-items: right;">
                        <button mat-flat-button color="primary" (click)="selectNote(row.noteId)"
                            i18n-matTooltip="@@payment-note-list.table.column.options.button.tool-tip"
                            matTooltip="payment-note-list.table.column.options.button.tool-tip"
                            i18n="@@payment-note-list.table.column.options.button.label">
                            payment-note-list.table.column.options.button.label
                        </button>
                    </mat-card-actions>
                </mat-card>

            </ng-container>
        </ng-container>
    </div>
    <div fxLayout="column" style="margin-top: 16px" *ngIf="openNotesPaymentInfoListFound && displayNotices">
        <div *ngIf="isBrowserIE; else paymentNoteListNoticesFlexColumnTemplate"
            [ngClass]="{ 'ie-display': isBrowserIE }">
            <ng-container *ngTemplateOutlet="paymentNoteListNoticesFlexColumnTemplate"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #paymentNoteListFlexColumnTemplate>
    <div fxLayout="column">
        <div class="display-text normal-paragraph-spacing" style="text-align: center" *ngIf="showSpinner">
            <mat-spinner color="accent" diameter="32"></mat-spinner>
        </div>
        <div fxLayout="column" *ngIf="!showSpinner">
            <div *ngIf="isBrowserIE; else paymentNoteListTableFlexColumnTemplate"
                [ngClass]="{ 'ie-display': isBrowserIE }">
                <ng-container *ngTemplateOutlet="paymentNoteListTableFlexColumnTemplate"></ng-container>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #paymentNoteListTableFlexColumnTemplate>
    <div fxFlex="100%" class="display-text primary-dark-color-important" *ngIf="displayTitle">
        <b><span i18n="@@payment-note-list.table.title">payment-note-list.table.title</span></b>
    </div>

    <div fxFlex="100%" class="display-text title-spacer" *ngIf="!openNotesPaymentInfoListFound">
        <i><span i18n="@@payment-note-list.table.no-records">payment-note-list.table.no-records</span></i>
    </div>

    <div class="display-text primary-dark-color-important normal-paragraph-spacing">
        <b><span
                i18n="@@payment-note.stepper.step1.pending-payments">payment-note.stepper.step1.pending-payments</span>&nbsp;
            {{pendingPayment.pendingPaymentAmt | currency}}</b>
    </div>

    <div fxFlex="100%" [ngStyle]="{ display: tableDisplayStyle }">
        <mat-table #table [dataSource]="tableDataSource" ngClass.lt-md="small-table-text">
            <!-- noteId Column -->
            <ng-container matColumnDef="noteId">
                <mat-header-cell *matHeaderCellDef fxFlex="9%">
                    <span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                        i18n="@@payment-note-list.table.column-header.note-id">payment-note-list.table.column-header.note-id</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="9%" ngClass.lt-md="small-table-text"
                    [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
                    row.noteId
                    }}</mat-cell>
            </ng-container>
            <!-- nextPaymentDueDate Column -->
            <ng-container matColumnDef="nextPaymentDueDate">
                <mat-header-cell *matHeaderCellDef fxFlex="9%">
                    <span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                        i18n="@@payment-note-list.table.column-header.next-payment-due-date">payment-note-list.table.column-header.next-payment-due-date</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="9%" ngClass.lt-md="small-table-text"
                    [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
                    row.nextPaymentDueDate
                    }}</mat-cell>
            </ng-container>
            <!-- noteDate Column -->
            <ng-container matColumnDef="noteDate">
                <mat-header-cell *matHeaderCellDef fxFlex="9%">
                    <span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                        i18n="@@payment-note-list.table.column-header.note-date">payment-note-list.table.column-header.note-date</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="9%" ngClass.lt-md="small-table-text"
                    [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
                    row.noteDate
                    }}</mat-cell>
            </ng-container>
            <!-- noteStatus Column -->
            <ng-container matColumnDef="noteStatus">
                <mat-header-cell *matHeaderCellDef fxFlex="10%">
                    <span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                        i18n="@@payment-note-list.table.column-header.note-status">payment-note-list.table.column-header.note-status</span>
                    <a class="tooltip-link" (click)="openToolTip('noteStatus')">
                        <mat-icon class="tooltip-icon-link" matTooltip="{{ getToolTip('noteStatus') }}"
                            matTooltipPosition="after" matTooltipClass="tooltip-multi-line">help_outline</mat-icon>
                    </a>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="10%" ngClass.lt-md="small-table-text"
                    [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
                    row.noteStatus
                    }}</mat-cell>
            </ng-container>
            <!-- pastDueAmount Column -->
            <ng-container matColumnDef="pastDueAmount">
                <mat-header-cell *matHeaderCellDef fxFlex="9%">
                    <span class="header-superscript header-after-content-2"
                        [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                        i18n="@@payment-note-list.table.column-header.past-due-amount">payment-note-list.table.column-header.past-due-amount</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="9%" ngClass.lt-md="small-table-text"
                    [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
                    row.pastDueAmount | currency
                    }}</mat-cell>
            </ng-container>
            <!-- lateFeeDue Column -->
            <ng-container matColumnDef="lateFeeDue">
                <mat-header-cell *matHeaderCellDef fxFlex="9%">
                    <span class="header-superscript header-after-content-1"
                        [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                        i18n="@@payment-note-list.table.column-header.late-fee-due">payment-note-list.table.column-header.late-fee-due</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="9%" ngClass.lt-md="small-table-text"
                    [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
                    row.lateFeeDue | currency
                    }}</mat-cell>
            </ng-container>
            <!-- regularPaymentAmount Column -->
            <ng-container matColumnDef="regularPaymentAmount">
                <mat-header-cell *matHeaderCellDef fxFlex="9%">
                    <span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                        i18n="@@payment-note-list.table.column-header.regular-payment-amount">payment-note-list.table.column-header.regular-payment-amount</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="9%" ngClass.lt-md="small-table-text"
                    [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
                    row.regularPaymentAmount | currency
                    }}</mat-cell>
            </ng-container>
            <!-- totalAmountDue Column -->
            <ng-container matColumnDef="totalAmountDue">
                <mat-header-cell *matHeaderCellDef fxFlex="9%">
                    <span class="header-superscript header-after-content-3"
                        [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                        i18n="@@payment-note-list.table.column-header.total-amount-due">payment-note-list.table.column-header.total-amount-due</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="9%" ngClass.lt-md="small-table-text"
                    [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
                    row.totalAmountDue | currency
                    }}</mat-cell>
            </ng-container>
            <!-- payoffAmount Column -->
            <ng-container matColumnDef="payoffAmount">
                <mat-header-cell *matHeaderCellDef fxFlex="9%">
                    <span class="header-superscript header-after-content-4"
                        [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                        i18n="@@payment-note-list.table.column-header.payoff-amount">payment-note-list.table.column-header.payoff-amount</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="9%" ngClass.lt-md="small-table-text"
                    [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
                    row.payoffAmount | currency
                    }}</mat-cell>
            </ng-container>
            <!-- autoPayFlag Column -->
            <ng-container matColumnDef="autoPayFlag">
                <mat-header-cell *matHeaderCellDef fxFlex="9%">
                    <span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                        i18n="@@payment-note-list.table.column-header.auto-pay-flag">payment-note-list.table.column-header.auto-pay-flag</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="9%" ngClass.lt-md="small-table-text"
                    [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
                    row.autoPayFlag
                    }}</mat-cell>
            </ng-container>
            <!-- options Column -->
            <ng-container matColumnDef="options">
                <mat-header-cell *matHeaderCellDef fxFlex="9%">
                    <span class="header-superscript header-after-content-5" *ngIf="CompanyCode_Check()"
                        [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                        i18n="@@payment-note-list.table.column-header.options">payment-note-list.table.column-header.options</span>
                    <span *ngIf="!CompanyCode_Check()" [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                        i18n="@@payment-note-list.table.column-header.options">payment-note-list.table.column-header.options</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="9%" class="mat-column-data-centered"
                    ngClass.lt-md="small-table-text">
                    <span [ngClass]="{ 'mat-column-options-ie': isBrowserIE }">
                        <button mat-flat-button color="primary" fxHide.lt-md (click)="selectNote(row.noteId)"
                            i18n-matTooltip="@@payment-note-list.table.column.options.button.tool-tip"
                            matTooltip="payment-note-list.table.column.options.button.tool-tip"
                            i18n="@@payment-note-list.table.column.options.button.label">
                            payment-note-list.table.column.options.button.label
                        </button>
                        <a class="button-link" fxHide.gt-sm (click)="selectNote(row.noteId)"
                            i18n-matTooltip="@@payment-note-list.table.column.options.anchor.tool-tip"
                            matTooltip="payment-note-list.table.column.options.anchor.tool-tip"
                            i18n="@@payment-note-list.table.column.options.anchor.label">payment-note-list.table.column.options.anchor.label</a>
                    </span>
                </mat-cell>
            </ng-container>

            <!-- Group Footer -->
            <ng-container matColumnDef="groupFooterTotals">
                <td class="mat-cell-group-footer" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }"
                    style="padding-right: 20px; text-align: right;" mat-cell *matCellDef="let groupFooter" fxFlex="37%"
                    fxLayoutAlign="end center">
                    <strong><span
                            i18n="@@payment-note-list.table.group-footer.pay-group">payment-note-list.table.group-footer.pay-group</span>:</strong>
                </td>
            </ng-container>
            <ng-container matColumnDef="groupFooterPastDueAmountTotal">
                <td class="mat-cell-group-footer" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }" mat-cell
                    *matCellDef="let groupFooter" fxFlex="9%" fxLayoutAlign="start center">
                    <strong>{{ groupFooter.pastDueAmountTotal | currency }}</strong>
                </td>
            </ng-container>
            <ng-container matColumnDef="groupFooterLateFeeDueTotal">
                <td class="mat-cell-group-footer" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }" mat-cell
                    *matCellDef="let groupFooter" fxFlex="9%" fxLayoutAlign="start center">
                    <strong>{{ groupFooter.lateFeeDueTotal | currency }}</strong>
                </td>
            </ng-container>
            <ng-container matColumnDef="groupFooterRegularPaymentAmountTotal">
                <td class="mat-cell-group-footer" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }" mat-cell
                    *matCellDef="let groupFooter" fxFlex="9%" fxLayoutAlign="start center">
                    <strong>{{ groupFooter.regularPaymentAmountTotal | currency }}</strong>
                </td>
            </ng-container>
            <ng-container matColumnDef="groupFooterTotalAmountDueTotal">
                <td class="mat-cell-group-footer" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }" mat-cell
                    *matCellDef="let groupFooter" fxFlex="9%" fxLayoutAlign="start center">
                    <strong>{{ groupFooter.totalAmountDueTotal | currency }}</strong>
                </td>
            </ng-container>
            <ng-container matColumnDef="groupFooterPayoffAmountTotal">
                <td class="mat-cell-group-footer" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }" mat-cell
                    *matCellDef="let groupFooter" fxFlex="9%" fxLayoutAlign="start center">
                    <strong>{{ groupFooter.payoffAmountTotal | currency }}</strong>
                </td>
            </ng-container>
            <ng-container matColumnDef="groupFooterAutoPayFlagTotal">
                <td class="mat-cell-group-footer" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }" mat-cell
                    *matCellDef="let groupFooter" fxFlex="9%" fxLayoutAlign="start center">
                    <strong>{{ groupFooter.autoPayFlagTotal }}</strong>
                </td>
            </ng-container>
            <ng-container matColumnDef="groupFooterOptions">
                <td class="mat-cell-group-footer" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }" mat-cell
                    *matCellDef="let groupFooter" fxFlex="9%" fxLayoutAlign="start center">
                    <span [ngClass]="{ 'mat-column-options-ie': isBrowserIE }">
                        <button mat-flat-button color="primary" fxHide.lt-md
                            (click)="selectPayGroup(groupFooter.paymentGroup)"
                            i18n-matTooltip="@@payment-note-list.table.group-footer.options.button.tool-tip"
                            matTooltip="payment-note-list.table.column.options.button.tool-tip"
                            i18n="@@payment-note-list.table.group-footer.options.button.label">
                            payment-note-list.table.group-footer.options.button.label
                        </button>
                        <a class="button-link" fxHide.gt-sm (click)="selectPayGroup(groupFooter.paymentGroup)"
                            i18n-matTooltip="@@payment-note-list.table.group-footer.options.anchor.tool-tip"
                            matTooltip="payment-note-list.table.group-footer.options.anchor.tool-tip"
                            i18n="@@payment-note-list.table.group-footer.options.anchor.label">payment-note-list.table.group-footer.options.anchor.label</a>
                    </span>
                </td>
            </ng-container>
            <tr mat-row class="mat-row-group-footer" *matRowDef="
          let row;
          columns: [
            'groupFooterTotals',
            'groupFooterPastDueAmountTotal',
            'groupFooterLateFeeDueTotal',
            'groupFooterRegularPaymentAmountTotal',
            'groupFooterTotalAmountDueTotal',
            'groupFooterPayoffAmountTotal',
            'groupFooterAutoPayFlagTotal',
            'groupFooterOptions'
          ];
          when: isGroupFooter
        "></tr>

            <mat-header-row class="primary-light-bg-top-to-bottom-gradient" *matHeaderRowDef="tableDisplayedColumns"
                ngClass.lt-md="small-header-row"></mat-header-row>
            <mat-row *matRowDef="let row; columns: tableDisplayedColumns" ngClass.lt-md="small-row"
                [ngClass]="{ 'primary-lightest-bg': row.noteId === selectedNoteId }"></mat-row>
        </mat-table>

        <div fxLayoutAlign="end center" class="small-display-text primary-light-color"
            *ngIf="openNotesPaymentInfoListFound">
            <app-table-record-count [recordCount]="openNotesPaymentInfoList.length"
                i18n-singularLabel="@@payment-note-list.table.record-count.singular-label"
                singularLabel="payment-note-list.table.record-count.singular-label"
                i18n-multipleLabel="@@payment-note-list.table.record-count.multiple-label"
                multipleLabel="payment-note-list.table.record-count.multiple-label"></app-table-record-count>
        </div>
        <div fxLayout="column" style="margin-top: 16px" *ngIf="openNotesPaymentInfoListFound && displayNotices">
            <div *ngIf="isBrowserIE; else paymentNoteListNoticesFlexColumnTemplate"
                [ngClass]="{ 'ie-display': isBrowserIE }">
                <ng-container *ngTemplateOutlet="paymentNoteListNoticesFlexColumnTemplate"></ng-container>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #paymentNoteListNoticesFlexColumnTemplate>
    <div fxFlex="100%" class="display-text">
        <sup>1</sup>&nbsp;<span i18n="@@payment-note-list.notices.1">payment-note-list.notices.1</span>
    </div>
    <div fxFlex="100%" class="display-text">
        <sup>2</sup>&nbsp;<span i18n="@@payment-note-list.notices.2">payment-note-list.notices.2</span>
    </div>
    <div fxFlex="100%" class="display-text">
        <sup>3</sup>&nbsp;<span i18n="@@payment-note-list.notices.3">payment-note-list.notices.3</span>
    </div>
    <div fxFlex="100%" class="display-text">
        <sup>4</sup>&nbsp;<span i18n="@@payment-note-list.notices.4a">payment-note-list.notices.4a</span>&nbsp;<b><span
                i18n="@@payment-note-list.notices.4b">payment-note-list.notices.4b</span></b>&nbsp;<span
            i18n="@@payment-note-list.notices.4c">payment-note-list.notices.4c</span>
    </div>
    <div fxFlex="100%" class="display-text" *ngIf="CompanyCode_Check()">
        <sup>5</sup>&nbsp;<b><span i18n="@@payment-note-list.notices.5a">payment-note-list.notices.5a</span>&nbsp;
            <a target="_blank" href="https://www.tuitionoptions.com/about-payments">
                <span i18n="@@payment-note-list.notices.5b">payment-note-list.notices.5b</span>
            </a>&nbsp;
            <span i18n="@@payment-note-list.notices.5c">payment-note-list.notices.5c</span>
        </b>
    </div>
</ng-template>

<ng-template #paymentNoteListCardViewHeaderTemplate>
    <div class="display-text primary-dark-color-important normal-paragraph-spacing">
        <b><span
                i18n="@@payment-note.stepper.step1.pending-payments">payment-note.stepper.step1.pending-payments</span>&nbsp;
            {{ pendingPayment.pendingPaymentAmt | currency }}</b>
    </div>
</ng-template>
